/**
 * Quote Slider Component
 * Requires jQuery
 */
(function($) {
	'use strict';

	function initQuoteSlider() {
		const $slider = $(".slider");

		// Exit if no slider found
		if (!$slider.length) return;

		const $track = $slider.find(".slider__track");
		const $slides = $slider.find(".slider__slide");
		const $prevBtn = $slider.find(".slider__button--prev");
		const $nextBtn = $slider.find(".slider__button--next");
		const $indicators = $slider.find(".slider__indicator");
		const $liveRegion = $slider.find(".slider__sr-only");

		const totalSlides = $slides.length;

		// Exit if no slides
		if (totalSlides === 0) return;

		let shuffledIndices = [];
		let currentPosition = 0;

		// Create a shuffled sequence of slide indices (only happens once on page load)
		function createShuffledSequence() {
			shuffledIndices = Array.from({ length: totalSlides }, (_, i) => i);

			// Fisher-Yates shuffle algorithm
			for (let i = shuffledIndices.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[shuffledIndices[i], shuffledIndices[j]] = [
					shuffledIndices[j],
					shuffledIndices[i]
				];
			}
		}

		// Initialize with shuffled sequence
		createShuffledSequence();

		function updateSlider(newPosition, announce = true) {
			currentPosition = newPosition;
			const currentSlideIndex = shuffledIndices[currentPosition];

			// Remove active class from all slides
			$slides.removeClass("slider__slide--active");

			// Add active class to current slide
			$slides.eq(currentSlideIndex).addClass("slider__slide--active");

			// Update ARIA attributes
			$slides.each(function (i) {
				$(this).attr("aria-hidden", i !== currentSlideIndex);
			});

			// Update indicators to show current position (not slide index)
			$indicators.each(function (i) {
				const isActive = i === currentPosition;
				$(this)
					.toggleClass("slider__indicator--active", isActive)
					.attr("aria-selected", isActive);
			});

			// Announce to screen readers
			if (announce) {
				const slideLabel = $slides.eq(currentSlideIndex).attr("aria-label");
				$liveRegion.text(`${slideLabel}`);
			}
		}

		// Previous button
		$prevBtn.on("click", function () {
			let newPosition = currentPosition - 1;
			if (newPosition < 0) {
				newPosition = totalSlides - 1;
			}
			updateSlider(newPosition);
		});

		// Next button
		$nextBtn.on("click", function () {
			let newPosition = currentPosition + 1;
			if (newPosition >= totalSlides) {
				newPosition = 0;
			}
			updateSlider(newPosition);
		});

		// Indicator buttons
		$indicators.on("click", function () {
			const position = $(this).index();
			updateSlider(position);
		});

		// Keyboard navigation
		$slider.on("keydown", function (e) {
			if (e.key === "ArrowLeft") {
				e.preventDefault();
				let newPosition = currentPosition - 1;
				if (newPosition < 0) {
					newPosition = totalSlides - 1;
				}
				updateSlider(newPosition);
			} else if (e.key === "ArrowRight") {
				e.preventDefault();
				let newPosition = currentPosition + 1;
				if (newPosition >= totalSlides) {
					newPosition = 0;
				}
				updateSlider(newPosition);
			}
		});

		// Touch/swipe support
		let touchStartX = 0;
		let touchEndX = 0;

		$slider.on("touchstart", function (e) {
			touchStartX = e.originalEvent.changedTouches[0].screenX;
		});

		$slider.on("touchend", function (e) {
			touchEndX = e.originalEvent.changedTouches[0].screenX;
			handleSwipe();
		});

		function handleSwipe() {
			const swipeThreshold = 50;
			const diff = touchStartX - touchEndX;

			if (Math.abs(diff) > swipeThreshold) {
				if (diff > 0) {
					// Swipe left - next
					let newPosition = currentPosition + 1;
					if (newPosition >= totalSlides) {
						newPosition = 0;
					}
					updateSlider(newPosition);
				} else {
					// Swipe right - prev
					let newPosition = currentPosition - 1;
					if (newPosition < 0) {
						newPosition = totalSlides - 1;
					}
					updateSlider(newPosition);
				}
			}
		}

		// Initialize with first position (position 0)
		updateSlider(0, false);
	}

	// Initialize on document ready
	$(document).ready(function() {
		initQuoteSlider();
	});

})(window.jQuery);
